import isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@mui/styles';

const styles = () => ({

    container: ({ viewAnimation, initStyles }) => {
        const style = {
            display: 'flex',
            flexDirection: 'column !important',
            alignItems: 'center',
            position: 'fixed',
            height: '100dvh',
            width: '100vw',
            overflow: 'hidden',
            backgroundColor: '#ffffff',
            boxSizing: 'border-box',
            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 40px)',
        };

        if (viewAnimation) {
            styles.opacity = 0;
        }

        if (!isEmpty(initStyles)) {
            styles.transform = initStyles.transform;
            styles.opacity = initStyles.opacity;
        }

        return style;
    },

    content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '24px 32px',
        maxWidth: 360,
        minHeight: 0,
    },

    logoImage: {
        width: 80,
        height: 80,
        marginBottom: 40,
    },

    title: {
        fontSize: '24px !important',
        fontWeight: '500 !important',
        lineHeight: '1.3 !important',
        color: '#1a1a1a',
        marginBottom: '12px !important',
    },

    description: {
        color: '#666',
        lineHeight: '24px !important',
        fontSize: '16px !important',
    },

    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
        paddingBottom: 20,
        gap: 6,
    },

    securityText: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontSize: '16px !important',
        color: '#555',
    },

    lockIcon: {
        fontSize: '1.2rem !important',
        marginRight: '4px !important',
    },

    footerLogo: {
        height: 21,
        width: 126,
        width: 'auto',
    },

    arrowContainer: {
        position: 'absolute',
        width: 80,
    },

    topArrow: {
        top: 16,
        right: 16,
    },

    bottomArrow: {
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 96px)',
        right: 16,
    },

    bottomCenterArrow: {
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 80px)',
        left: '50%',
        transform: 'translateX(-65%)',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
